'use client';

/*
 * Documentation:
 * Avatar — https://app.subframe.com/6fc7f5fbb098/library?component=Avatar_bec25ae6-5010-4485-b46b-cf79e3943ab2
 * Badge — https://app.subframe.com/6fc7f5fbb098/library?component=Badge_97bdb082-1124-4dd7-a335-b14b822d0157
 * BasicCard01 — https://app.subframe.com/6fc7f5fbb098/library?component=BasicCard01_b14af4b1-2383-42b9-a53f-2fc241cc8f41
 * Icon Button — https://app.subframe.com/6fc7f5fbb098/library?component=Icon+Button_af9405b1-8c54-4e01-9786-5aad308224f6
 * Icon with background — https://app.subframe.com/6fc7f5fbb098/library?component=Icon+with+background_c5d68c0e-4c0c-4cff-8d8c-6ff334859b3a
 */
import React from 'react';
import { FeatherCheck } from '@subframe/core';
import { FeatherFileText } from '@subframe/core';
import { FeatherMoreHorizontal } from '@subframe/core';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
import { Avatar, Badge, IconButton, IconWithBackground } from '../common';
interface BasicCard01RootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  author?: React.ReactNode;
  tags?: React.ReactNode;
  userName?: React.ReactNode;
  modifiedDate?: React.ReactNode;
  menuActions?: React.ReactNode;
  className?: string;
}
const BasicCard01Root = React.forwardRef<HTMLDivElement, BasicCard01RootProps>(function BasicCard01Root({
  icon = <FeatherFileText />,
  title,
  author,
  tags,
  userName,
  modifiedDate,
  menuActions,
  className,
  ...otherProps
}: BasicCard01RootProps, ref) {
  return <div className={SubframeUtils.twClassNames('group/b14af4b1 bg-default-background hover:bg-brand-50 flex cursor-pointer flex-col items-start gap-4 rounded-[16px] border border-solid border-neutral-200 px-6 py-6', className)} ref={ref} {...otherProps}>
        <div className="flex w-full items-start gap-4">
          <IconWithBackground variant="brand" size="large" icon={<FeatherCheck />} square={false} />
          <div className="flex shrink-0 grow basis-0 flex-col items-start gap-1">
            {title ? <span className="text-body-bold font-body-bold text-default-font line-clamp-2 w-full">
                {title}
              </span> : null}
            <div className="flex items-center gap-2">
              {author ? <span className="text-caption font-caption text-subtext-color">{author}</span> : null}
              <span className="text-caption font-caption text-neutral-400">•</span>
              <Badge>Badge</Badge>
            </div>
          </div>
          <SubframeCore.DropdownMenu.Root>
            <SubframeCore.DropdownMenu.Trigger asChild={true}>
              <IconButton size="small" icon={<FeatherMoreHorizontal />} />
            </SubframeCore.DropdownMenu.Trigger>
            <SubframeCore.DropdownMenu.Portal>
              <SubframeCore.DropdownMenu.Content side="bottom" align="end" sideOffset={4} asChild={true}>
                {menuActions ? <div className="flex items-start justify-between">{menuActions}</div> : null}
              </SubframeCore.DropdownMenu.Content>
            </SubframeCore.DropdownMenu.Portal>
          </SubframeCore.DropdownMenu.Root>
        </div>
        <div className="flex w-full items-center gap-2">
          {tags ? <div className="flex items-center gap-2">{tags}</div> : null}
        </div>
        <div className="flex w-full items-center gap-2">
          <div className="flex items-center gap-1">
            <Avatar size="x-small" image="https://res.cloudinary.com/subframe/image/upload/v1711417507/shared/fychrij7dzl8wgq2zjq9.avif">
              A
            </Avatar>
            {userName ? <span className="text-caption font-caption text-subtext-color">{userName}</span> : null}
          </div>
          <span className="text-caption font-caption text-neutral-400">•</span>
          {modifiedDate ? <span className="text-caption font-caption text-subtext-color">{modifiedDate}</span> : null}
        </div>
      </div>;
});
export const BasicCard01 = BasicCard01Root;